import { getFormIdFromUrl } from "../../helpers/getUrlParams";
import { api } from "../api";
import { ApiDynamicPaths } from "../api/paths";
import {
    IChangeOrderRequestData,
    IChangePageData,
    ICreatePageRequestData,
    IDeletePageRequestData,
    IUpdatePageData,
} from "./../../store/pages/types";
import {
    ChangePageOrderResponse,
    CreatePageResponse,
    DeletePageResponse,
    UpdatePageDataResponse,
    UpdatePageResponse,
} from "./pages.service.d";

export class PagesService {
    /**
     * Create Page request
     *
     * @param  {ICreatePageRequestData} createPageRequestData
     */
    static async createPage(data: ICreatePageRequestData): Promise<CreatePageResponse> {
        return api.post(ApiDynamicPaths({ form_id: getFormIdFromUrl() }).CREATE_PAGE, data);
    }

    /**
     * Delete page request
     *
     * @param  {IDeletePageRequestData} deletePageRequestData
     */
    static async deletePage(data: IDeletePageRequestData): Promise<DeletePageResponse> {
        const { id: page_id, removeFields } = data;
        return api.delete(ApiDynamicPaths({ form_id: getFormIdFromUrl(), page_id, removeFields }).DELETE_PAGE);
    }

    /**
     * Change page request
     *
     * @param  {IChangeOrderData} chnagePageOrderRequestData
     */
    static async changePageOrder({
        pageId,
        dropIndex,
    }: Partial<IChangeOrderRequestData>): Promise<ChangePageOrderResponse> {
        return api.post(ApiDynamicPaths({ form_id: getFormIdFromUrl(), page_id: pageId }).UPDATE_PAGE_ORDER, {
            position: dropIndex,
        });
    }

    /**
     * Update Page request
     *
     * @param  {IUpdatePageData} updatePageResponse
     */
    static async updatePage({ _id, title }: IUpdatePageData): Promise<UpdatePageResponse> {
        return api.put(ApiDynamicPaths({ form_id: getFormIdFromUrl(), page_id: _id }).UPDATE_PAGE, { title });
    }

    static async updatePageData({ data }: IChangePageData): Promise<UpdatePageDataResponse> {
        return api.put(ApiDynamicPaths({ form_id: getFormIdFromUrl() }).UPDATE_PAGES, [...data]);
    }
}
